import React from "react";

function BusinessCases({ backgroundCol, firstTitle, midTitle, secondTitle, midCol, para }) {
  return (
    <div className={`${backgroundCol ? backgroundCol : "bg-midBlue"}  flex items-center justify-center`}>
      <div className=" xl:w-7/12 lg:w-9/12 w-full  flex-col items-center justify-center text-white py-20 text-center">
        <h2 className="text-4xl font-bold font-secondary">
          {firstTitle ? firstTitle : ""} {midTitle ? <span className={`${midCol ? midCol : "text-orange"} `}>{midTitle} </span> : "Use"}
          {secondTitle ? secondTitle : ""}
        </h2>
        <p className="font-opensans text-darkMist mt-10">{para ? para : "There are many common use cases for our technical translations done by our technical translators, including:"}</p>
        <div className="bottom grid grid-cols-1 lg:grid-cols-2 xl:place-items-center pl-8 lg:pl-0  w-full  text-left pt-16 font-light">
          <ul className="list-disc text-[22px] mb-6 lg:mb-0">
            <li className="pb-6">Business Website</li>
            <li className="pb-6">Advertising and Marketing Collateral</li>
            <li className="pb-6">Presentations</li>
            <li className="pb-6">Pitch Decks</li>
            <li className="pb-6">Business Proposals</li>
          </ul>
          <ul className="list-disc text-[22px]">
            <li className="pb-6">Manuals</li>
            <li className="pb-6">Technical Documentation</li>
            <li className="pb-6">Brochure and Catalogs</li>
            <li className="pb-6">Financial Reports</li>
            <li className="pb-6">Confidentiality Agreements</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default BusinessCases;
